import Vue from 'vue';
import ElementUI from 'element-ui';
import login from './index.vue';
import 'element-ui/lib/theme-default/index.css';
import '../../assets/css/reset.scss';
import '../../assets/css/common.scss';
import '../../assets/css/iconfont.css';

Vue.use(ElementUI)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<login/>',
  components: { login }
});



// WEBPACK FOOTER //
// ./src/admin/sign-in/index.js